import React from 'react';
import { Briefcase } from 'lucide-react';
import { Section, ToggleRow } from '../workersetting/settinghelper/SettingsHelpers';

const PreferencesSection = ({
  push_notifications,
  email_notifications,
  availablity,
  setAvailablity,
  updateSetting
}) => {
  return (
    <Section title="PREFERENCES">

      <ToggleRow
        icon={<Briefcase size={20} />}
        iconColor="#10b981"
        iconBg="#e6f9f2"
        title="Available for Work"
        subtitle="Show as available to customers"
        checked={availablity}
        onToggle={(value) => {
          setAvailablity(value);
          updateSetting(push_notifications, email_notifications, value);
        }}
      />

    </Section>
  );
};

export default PreferencesSection;